/* Cadeaux par paliers : ajoute et retire les produits cadeaux selon le
   sous-total du panier (hors cadeaux). Aucun moteur de reduction. */
(function(){
  'use strict';
  var T1=4900, T2=8900, G1=47579540291740, G2=47579540324508;
  var VALEUR={}; VALEUR[G1]='13,99 €'; VALEUR[G2]='26,90 €';
  var busy=false;

  function afficherOffert(){
    document.querySelectorAll('.cart-item, cart-drawer .cart-item').forEach(function(row){
      var a=row.querySelector('a[href*="/products/cadeau-"]');
      if(!a) return;
      var val=/mala-ebene/.test(a.getAttribute('href')) ? VALEUR[G2] : VALEUR[G1];
      row.querySelectorAll('.price, .cart-item__price-wrapper > *, .cart-item__details > .product-option, .cart-item__details .price, cart-drawer .cart-item__details > *').forEach(function(p){
        if(p.childElementCount===0 && /^0[,.]00\s*€?$/.test(p.textContent.trim().replace(/\u00a0/g,' ').replace('€','').trim()+'')){
          p.innerHTML='<s class="lb-was">'+val+'</s><span class="lb-free">OFFERT</span>';
        }
      });
    });
  }

  function sync(){
    if(busy) return;
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var l1=[],l2=[],sub=0;
      cart.items.forEach(function(i){
        if(i.variant_id===G1) l1.push(i);
        else if(i.variant_id===G2) l2.push(i);
        else sub+=i.original_line_price;
      });
      var ajouts=[], retraits=[];
      if(sub>=T1 && l1.length===0) ajouts.push(G1);
      if(sub< T1) l1.forEach(function(i){ retraits.push(i.key); });
      if(sub>=T2 && l2.length===0) ajouts.push(G2);
      if(sub< T2) l2.forEach(function(i){ retraits.push(i.key); });
      // un seul exemplaire de chaque cadeau
      [l1,l2].forEach(function(l){ if(l.length && l[0].quantity>1) retraits.push({k:l[0].key,q:1}); });
      if(!ajouts.length && !retraits.length){ afficherOffert(); return; }
      busy=true;
      var chaine=Promise.resolve();
      ajouts.forEach(function(id){
        chaine=chaine.then(function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}]})}); });
      });
      retraits.forEach(function(r){
        var corps = (typeof r==='object') ? {id:r.k,quantity:r.q} : {id:r,quantity:0};
        chaine=chaine.then(function(){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(corps)}); });
      });
      chaine.then(function(){
        busy=false;
        document.dispatchEvent(new CustomEvent('lb:cadeaux-maj'));
        if(window.location.pathname.indexOf('/cart')===0) window.location.reload();
        else {
          var d=document.querySelector('cart-drawer');
          if(d && typeof d.renderContents==='function'){
            fetch('/?sections=cart-drawer,cart-icon-bubble').then(function(r){return r.json();}).then(function(s){
              d.renderContents({sections:s}); setTimeout(afficherOffert,120);
            });
          } else setTimeout(afficherOffert,200);
        }
      }).catch(function(){ busy=false; });
    }).catch(function(){});
  }

  document.addEventListener('DOMContentLoaded', function(){ sync(); afficherOffert(); });
  ['cart:updated','cart-drawer:open'].forEach(function(e){ document.addEventListener(e, function(){ setTimeout(sync,200); }); });
  var of_=window.fetch;
  window.fetch=function(){
    var u=arguments[0];
    var p=of_.apply(this,arguments);
    if(typeof u==='string' && /\/cart\/(add|change|update)/.test(u) && !busy){ p.then(function(){ setTimeout(sync,250); }); }
    return p;
  };
})();